import React from 'react'

export default function SemPlanosAssinatura() {
    return (
        <div>Sem Planos de Assinatura para esta Aplicação</div>
    )
}
